import React from "react";
import styled from "styled-components";
import { breakpoints } from './constants';

const MainMenu = styled.nav`
  position: fixed;
  top: 0;
  left: 0;
  background: #3B3E4D;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 13px 2.5%;
  box-sizing:border-box;
  z-index: 5;
  opacity: ${props => props.show ? '1' : '0'};
  transition: .3s all;
  p, h1 {
    flex: 0 0 33.3%;
  }
  h1 {
    text-align:center;
  }
  @media (min-width: ${breakpoints.tablet}) {
    p, h1 {
      flex: none;
    }
  }
`;

export default MainMenu;



// WEBPACK FOOTER //
// ./src/styled-components/MainMenu.js